export default "__VITE_PUBLIC_ASSET__194cedd3__"